import { useUpdatePin } from '@lessonup/pin-renderer';
import { isMarkerType, LinePinComponent, MarkerType } from '@lessonup/pins-shared';
import { SelectField, SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React from 'react';
import { useEditorTranslation } from '../../../../../../hooks/useEditorTranslation';
import { setMarkerAction } from '../../../../../../utils/pinComponentSettings/linePinComponentSettings';

interface LinePointsSettingsProps {
  pinComponent: LinePinComponent;
}

export const LinePointsSettings: React.FC<LinePointsSettingsProps> = ({ pinComponent }) => {
  const dispatch = useUpdatePin();
  const { t } = useEditorTranslation();
  const startMarkerCurrentValue = pinComponent.settings.tailMarker ?? 'NONE';
  const endMarkerCurrentValue = pinComponent.settings.headMarker ?? 'NONE';

  const onChangeMarkerType = ({ startMarker, endMarker }: { startMarker?: string; endMarker?: string }) => {
    if (
      (startMarker === undefined || isMarkerType(startMarker)) &&
      (endMarker === undefined || isMarkerType(endMarker))
    ) {
      dispatch(
        setMarkerAction(pinComponent.id, {
          tailMarker: startMarker ?? startMarkerCurrentValue,
          headMarker: endMarker ?? endMarkerCurrentValue,
        })
      );
    }
  };

  const markerOptions: { label: string; value: MarkerType }[] = [
    { label: t('contextSidebar.settings.line.linePoints.markerTypeLabels.none'), value: 'NONE' },
    { label: t('contextSidebar.settings.line.linePoints.markerTypeLabels.arrow'), value: 'ARROW' },
  ];

  return (
    <SpaceBetween direction="x" spacing={spacing.size8}>
      <StyledSelect
        size="medium"
        label={t('contextSidebar.settings.line.linePoints.startPoint')}
        options={markerOptions}
        onChange={(e) => onChangeMarkerType({ startMarker: e.currentTarget.value })}
        value={startMarkerCurrentValue}
      />
      <StyledSelect
        size="medium"
        label={t('contextSidebar.settings.line.linePoints.endPoint')}
        options={markerOptions}
        onChange={(e) => onChangeMarkerType({ endMarker: e.currentTarget.value })}
        value={endMarkerCurrentValue}
      />
    </SpaceBetween>
  );
};

const StyledSelect = styled(SelectField)`
  width: 50%;
`;
